import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "報酬", -1)
const _hoisted_3 = { class: "text-mild text-size-14" }
const _hoisted_4 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "交通費", -1)
const _hoisted_6 = { class: "text-mild text-size-14" }
const _hoisted_7 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "源泉徴収額", -1)
const _hoisted_9 = { class: "text-mild text-size-14" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex justify-content-between mt-1"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "手数料", -1)
const _hoisted_12 = { class: "text-mild text-size-14" }
const _hoisted_13 = { class: "d-flex justify-content-between mt-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-size-16 text-weight-500" }, "総計", -1)
const _hoisted_15 = { class: "text-blue text-size-16 text-weight-500" }

import { formatCurrency } from "@/utils/number";
import BgWaveCard from "@/components/organisms/common/BgWaveCard.vue";
import { PropType } from "vue";
import { SalarySummary } from "@/types/balance/BalanceHistory";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalaryCard',
  props: {
  salarySummary: {
    type: Object as PropType<SalarySummary>,
    required: true
  }
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BgWaveCard, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(formatCurrency)(props.salarySummary.reward)), 1)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createTextVNode(),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(formatCurrency)(props.salarySummary.optionValue)), 1)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createTextVNode(),
        _createElementVNode("p", _hoisted_9, "\n        - " + _toDisplayString(_unref(formatCurrency)(props.salarySummary.withholdingTax)), 1)
      ]),
      _createTextVNode(),
      (props.salarySummary.commission > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(),
            _createElementVNode("p", _hoisted_12, "\n        - " + _toDisplayString(_unref(formatCurrency)(props.salarySummary.commission)), 1)
          ]))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createTextVNode(),
        _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(formatCurrency)(props.salarySummary.totalIncome)), 1)
      ])
    ], undefined, true),
    _: 1
  }))
}
}

})